import { Box, BoxProps } from '@chakra-ui/react'

export const CloseEye = ({ ...props }: BoxProps) => {
    return (
        <Box cursor={'pointer'} {...props}>
            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_4040_17306)">
                    <path d="M14.9091 5.83325C14.9091 5.83325 12.2425 9.83325 8.24247 9.83325C4.24247 9.83325 1.57581 5.83325 1.57581 5.83325" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                    <path d="M10.2424 9.5L11.2424 11.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M13.5758 7.83325L14.9091 9.16659" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M1.57581 9.1665L2.90914 7.83317" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M6.24243 9.5L5.24243 11.1667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_4040_17306">
                        <rect width="16" height="16" fill="white" transform="translate(0.242432 0.5)" />
                    </clipPath>
                </defs>
            </svg>
        </Box>
    )
}
